import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import ExamView from './views/ExamView.vue'
import ExamSetSelectView from './views/ExamSetSelectView.vue'
import SignupView from './views/SignupView.vue'
import PerformanceView from './views/PerformanceView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/exam-select/:year/:subject',
    name: 'exam-select',
    component: ExamSetSelectView,
    props: true
  },
  {
    path: '/exam/:year/:subject/:setId',
    name: 'exam',
    component: ExamView,
    props: true
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
    // We can pass query params to it if needed, e.g., to redirect after login
  },
  {
    path: '/performance',
    name: 'performance',
    component: PerformanceView,
    meta: { requiresAuth: true } // Add meta field for route guard
  },
  // Add a redirect route for incomplete exam URLs
  {
    path: '/exam/:year/:subject',
    redirect: to => {
      return `/exam-select/${to.params.year}/${to.params.subject}`
    }
  },
  // Catch-all route for debugging (optional)
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('./views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

import { useAuth } from './composables/useAuth'; // Import useAuth

// Navigation Guard
router.beforeEach((to, from, next) => {
  const { currentUser, loading } = useAuth();

  const performCheck = () => {
    if (loading.value) {
      // Auth state is still loading, wait a moment and re-check
      // This is a simple polling mechanism. For more complex apps,
      // consider an event bus or a promise from useAuth that resolves on initial auth load.
      setTimeout(performCheck, 50); // Check again in 50ms
      return;
    }

    // Auth state is resolved (loading.value is false)
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser.value) {
      // If route requires auth and user is not logged in (after loading is complete),
      // redirect to signup.
      next({ name: 'signup', query: { redirect: to.fullPath } });
    } else {
      // Otherwise, proceed as normal.
      next();
    }
  };

  performCheck();
});

export default router